import { Outlet } from "react-router-dom";
import YupchaIcon from '../../assets/image.png';
import YupchaTextLogo from '../../assets/Yupcha.webp';

export default function AuthLayout() {
  return (
    <div className="auth-layout">
      <div className="auth-container">
        {/* Left Promotional Panel */}
        <div className="auth-promo-panel">
            <div className="promo-logo">
              <img src={YupchaIcon} alt="Yupcha Icon" />
              <img src={YupchaTextLogo} alt="Yupcha" />
            </div>
            <div className="promo-text">
              <p className="promo-text-lead">You can easily</p>
              <h2 className="promo-text-heading">
                Get access your personal hub for clarity and productivity.
              </h2>
            </div>
        </div>

        {/* Right Form Panel */}
        <div className="auth-form-panel">
          <Outlet />
        </div>
      </div>
    </div>
  );
}